import LayoutApp from '@/layout/LayoutApp';
import HomePage from '../page/HomePage';
import PATH from './PATH';
// import BidPage from '../page/BidPage';
// import Result from '../page/Result';
// import Rule from '../page/Rule';
import LoginMobile from '../page/LoginMobile';
import AccountPage from '../page/AccountPage';
import PackagePage from '../page/PackagePage';
// import PackageHistory from '../page/PackageHistory';
// import AuctionRecord from '../page/AuctionRecord';
import ChangePassword from '../page/ChangePassword';
// import Event from '../page/Event';
import EventNewYearAndChristmas_2024 from '../page/EventNewYearAndChristmas_2024';
import EventThingyan_2025 from '../page/EventThingyan_2025';
import { ID_TAB_EVENT_THINGYAN_2025, ID_TAB_MINI_GAME, IS_UPDATE_VERSION_3_PROJECT, IS_UPDATE_VERSION_3_PROJECT_LOGIN } from '../helper/const';
import MiniGame from '../page/MiniGame';
import PieceCollection from '../page/components/MiniGame/PieceCollection';
import TakePrize from '../page/components/MiniGame/TakePrize';
// import PlaygroundPage from '../page/Playground';
import History from '@/page/history/History';
import ShweJourney from '@/page/shweJourney/ShweJourney';
import ShweVault from '@/page/ShweVault/ShweVault';
import Notification from '@/page/Notification';
import PrizePool from '@/page/PrizePool';
import DailyReward from "@/page/DailyReward";
import HelpCenter from '@/page/components/Account/HelpCenter';
import Rank from '@/page/Rank/Rank';
import LoyaltyPoint from '@/page/LoyaltyPoint/LoyaltyPoint';
import NotFound from '@/page/NotFound';

export const routerList = [
	// {
	// 	path: `${PATH.RESULT}/:id`,
	// 	component: Result,
	// 	layout: LayoutApp
	// },
	// {
	// 	path: `${PATH.RESULT}/:id/:idResult`,
	// 	component: Result,
	// 	layout: LayoutApp
	// },
	{
		path: PATH.HOME,
		component: HomePage,
		layout: LayoutApp,
		public: IS_UPDATE_VERSION_3_PROJECT_LOGIN //v3 chuyển thành true để không cần login
	},
	// {
	// 	path: `${PATH.BID}/:id`,
	// 	component: BidPage,
	// 	layout: LayoutApp
	// },
	{
		path: `${PATH.BID}/:id`,
		component: HomePage,
		layout: LayoutApp
	},
	// {
	// 	path: PATH.RULE,
	// 	component: Rule,
	// 	layout: LayoutApp
	// },
	// {
	// 	path: PATH.PLAYGROUND,
	// 	component: PlaygroundPage,
	// 	layout: LayoutApp,
	// },
	...(!IS_UPDATE_VERSION_3_PROJECT_LOGIN ? [{
		// public: không cần đăng nhập — nếu không sẽ lặp vô hạn (guard đá về đây).
		path: PATH.LOGIN,
		component: LoginMobile,
		layout: LayoutApp,
		public: true
	}] : []),
	{
		path: PATH.ACCOUNT,
		component: AccountPage,
		layout: LayoutApp
	},
	{
		path: PATH.PACKAGE,
		component: PackagePage,
		layout: LayoutApp
	},
	{
		path: PATH.PACKAGE_DAILY,
		component: PackagePage,
		layout: LayoutApp
	},
	{
		path: PATH.PACKAGE_WEEKLY,
		component: PackagePage,
		layout: LayoutApp
	},
	{
		path: PATH.PACKAGE_MONTHLY,
		component: PackagePage,
		layout: LayoutApp
	},
	{
		path: PATH.PACKAGE_SUB,
		component: PackagePage,
		layout: LayoutApp
	},
	// {
	// 	path: PATH.PACKAGE_HISTORY,
	// 	component: PackageHistory,
	// 	layout: LayoutApp
	// },
	// {
	// 	path: PATH.AUCTION_RECORD,
	// 	component: AuctionRecord,
	// 	layout: LayoutApp
	// },
	{
		path: PATH.CHANGE_PASSWORD,
		component: ChangePassword,
		layout: LayoutApp
	},
	// {
	// 	path: `${PATH.EVENT}/:id`,
	// 	component: Event,
	// 	layout: LayoutApp
	// },
	// {
	// 	path: `${PATH.EVENT_NEW_YEAR_CHRISTMAS}/:id`,
	// 	component: EventNewYearAndChristmas_2024,
	// 	layout: LayoutApp
	// },
	// {
	// 	path: `${PATH.EVENT_THINGYAN}/:id`,
	// 	component: EventThingyan_2025,
	// 	layout: LayoutApp
	// },
	// {
	// 	path: `${PATH.EVENT_THINGYAN}/${ID_TAB_EVENT_THINGYAN_2025.prizeCollection}/:idPrize`,
	// 	component: EventThingyan_2025,
	// 	layout: LayoutApp
	// },
	{
		path: `${PATH.MINI_GAME}/:id`,
		component: MiniGame,
		layout: LayoutApp,
		public: true
	},
	{
		path: `${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.pieceCollection}/:id`,
		component: PieceCollection,
		layout: LayoutApp,
		public: true
	},
	{
		path: `${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.pieceCollection}`,
		component: PieceCollection,
		layout: LayoutApp,
		public: true
	},
	{
		path: `${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.takePrize}/:id`,
		component: TakePrize,
		layout: LayoutApp,
		public: true
	},
	{
		path: `${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.takePrize}`,
		component: TakePrize,
		layout: LayoutApp,
		public: true
	},
	{
		path: `${PATH.MINI_GAME}/give/:id`,
		component: MiniGame,
		layout: LayoutApp,
		public: true
	},
	{
		path: `${PATH.MINI_GAME}/request/:id`,
		component: MiniGame,
		layout: LayoutApp,
		public: true
	},
	{
		path: `${PATH.MINI_GAME}/invite-user/:id`,
		component: MiniGame,
		layout: LayoutApp,
		public: true
	},
	{
		path: PATH.HISTORY,
		component: History,
		layout: LayoutApp,
		public: true
	},
	{
		path: PATH.SHWE_JOURNEY,
		component: ShweJourney,
		layout: LayoutApp
	},
	{
		path: PATH.SHWE_VAULT,
		component: ShweVault,
		layout: LayoutApp
	},
	{
		path: PATH.NOTIFICATION,
		component: Notification,
		layout: LayoutApp
	},
	{
		path: PATH.PRIZE_POOL,
		component: PrizePool,
		layout: LayoutApp,
		public: true
	},
	{
		path: PATH.DAILY_REWARD,
		component: DailyReward,
		layout: LayoutApp,
	},
	{
		path: PATH.HELP_CENTER,
		component: HelpCenter,
		layout: LayoutApp,
	},
	{
		path: PATH.RANK,
		component: Rank,
		layout: LayoutApp,
	},
	{
		path: PATH.LOYALTY_POINT,
		component: LoyaltyPoint,
		layout: LayoutApp,
	},
	{
		path: "*",
		component: NotFound,
		layout: LayoutApp,
		public: true
	}
]